import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "./Form";
import { CHAT, CHATALL, USERALL, MESSAGEREAD } from "../../services/actions";
import { Box, Grid, Typography, TextField, Button, Tooltip } from "@mui/material";

export default function Messages() {
  const dispatch = useDispatch();
  const userallState = useSelector((state) => state?.userallState);
  const chatallState = useSelector((state) => state?.chatallState);

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  let auth = useSelector((state) => state?.loginState?.auth);
  const [message, setMessage] = React.useState({});
  const [messages, setMessages] = React.useState([]);
  const [error, setError] = useState("");
  const messageEndRef = React.useRef(null);
  // Load users on mount
  useEffect(() => {
    dispatch({
      type: `${USERALL}_GET`,
      payload: 'user/0/?filter_by={"is_active":true}',
    });
  }, []);

  useEffect(() => {
    setUsers(userallState?.data?.results || []);
  }, [userallState?.data]);

  useEffect(() => {
    let filterdata = Array.isArray(chatallState.data)
      ? chatallState.data
      : [chatallState.data];
    filterdata = filterdata.filter((data) => data?.message_type === "chat");
    setMessages((prev) => [...prev,...filterdata]);
    // console.log("chat_view", messages);
  }, [chatallState.data]);

  React.useEffect(() => {
    if (messageEndRef.current) {
      messageEndRef.current.scrollTop = messageEndRef.current.scrollHeight;
    }
   // console.log("chat_view_1", messages);
  }, [messages, selectedUser]);

  // Handle user selection and sending messages
  const handleChange = (value, action) => {
    if (action === "users") {
      setSelectedUser(value);
      
      setError("");
      console.log("selectedUser", value,auth.id)
      // dispatch({
      //   type: `${MESSAGEREAD}_GET`,
      //   payload: `message_read/${auth?.id}/${value}/chat`,
      // });
     
    }
    if (action === "send-message") {
      if (!selectedUser) {
        setError("Please select a user before sending a message");
        return;
      }

     

      let data = {
        content: value.message,
        message_type: value.notification ? "notification" : "chat",
        sender: auth?.id,
        recipient: selectedUser,
      };
      //console.log(data, auth);
      dispatch({
        type: `${CHAT}_POST`,
        payload: data,
      });
      setError("");
    }
  };
  return (
    <Grid container spacing={2}>
      {/* LEFT - User List */}
      <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4, xxl: 4 }}>
        <Box sx={{ flexGrow: 1, mb: 2, p: 2 }}>
          <Typography fontWeight={600}>Users</Typography>
          <Box
            sx={{ flexGrow: 1, mb: 2, p: 2, height: 500, overflowY: "auto" }}
          >
            {users ?.filter((user) => user.id !== auth?.id) 
            .sort((a, b) => a.username.localeCompare(b.username))
            .map((user) => (
              <Box
                key={user.id}
                onClick={() => handleChange(user.id, "users")}
                sx={{
                  p: 2,
                  borderRadius: 1,
                  borderBottom: "1px solid #eee",
                  cursor: "pointer",
                  background:
                    selectedUser === user.id ? "#e0f7fa" : "transparent",
                  "&:hover": { background: "#f5f5f5" },
                }}
              >
                <Tooltip title={user.username}>
                <Typography fontWeight={600}>{user.first_name}</Typography>
                </Tooltip>
                
              </Box>
            ))}
          </Box>
        </Box>
      </Grid>

      {/* RIGHT - Messages + Input */}
      <Grid size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8, xxl: 8 }}>
        <Box sx={{ flexGrow: 1, mb: 2, p: 2 }}>
          {selectedUser && (
            <Box
              ref={messageEndRef}
              sx={{
                mt: 2,
                p: 2,
                background: "#fafafa",
                borderRadius: 2,
                height: 400,
                overflowY: "auto",
              }}
            >
              {(messages || []).map((msg, i) => {
                if (
                  (msg.recipient == auth?.id && msg.sender == selectedUser) ||
                  (msg.sender == auth?.id && msg.recipient == selectedUser)
                ) {
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        // background: msg.sender == auth?.id ? "#d1e7dd" : "#e2e3e5",
                        // alignSelf: msg.sender == auth?.id ? "flex-end" : "flex-start",
                      }}
                    >
                      <Box
                        key={i}
                        sx={{
                          p: 1,
                          mb: 1,
                          borderRadius: 2,
                          background: auth?.id ? "#d1e7dd" : "#e2e3e5",
                          alignSelf: auth?.id ? "flex-end" : "flex-start",
                          marginLeft: msg.sender == auth?.id ? "30px" : 0,
                          marginRight:
                            msg.recipient == auth?.id &&
                            msg.sender == selectedUser
                              ? "30px"
                              : 0,
                          background:
                            msg.sender == auth?.id ? "#d1e7dd" : "#e2e3e5",
                          alignSelf:
                            msg.sender == auth?.id ? "flex-end" : "flex-start",
                        }}
                      >
                        messages: {msg.content}
                      </Box>
                    </Box>
                  );
                }
              })}
            </Box>
          )}

          {/* Show error message */}
          {error && (
            <Typography sx={{ color: "red", mt: 1, fontSize: 13 }}>
              {error}
            </Typography>
          )}
          <Form onChange={handleChange} />
        </Box>
      </Grid>
    </Grid>
  );
  return <Box sx={{ p: 2 }}></Box>;
}
